var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFormClearLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5ZM6.37493 2.44656C6.59189 2.2296 6.94365 2.2296 7.1606 2.44656L7.55344 2.8394C7.7704 3.05635 7.7704 3.40811 7.55344 3.62507L6.17851 5L7.55344 6.37493C7.7704 6.59189 7.7704 6.94365 7.55344 7.1606L7.1606 7.55344C6.94365 7.7704 6.59189 7.7704 6.37493 7.55344L5 6.17851L3.62507 7.55344C3.40811 7.7704 3.05635 7.7704 2.8394 7.55344L2.44656 7.1606C2.2296 6.94365 2.2296 6.59189 2.44656 6.37493L3.82149 5L2.44656 3.62507C2.2296 3.40811 2.2296 3.05635 2.44656 2.8394L2.8394 2.44656C3.05635 2.2296 3.40811 2.2296 3.62507 2.44656L5 3.82149L6.37493 2.44656Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFormClearLink);
export default __webpack_public_path__ + "static/media/ico_form_clear_link.d384126c.svg";
export { ForwardRef as ReactComponent };